import { useState } from "react";
import { MUTATIONS, useMutation } from "../../../../../../api";
import DropdownMenuItem from "../../../../../../design-system/components/DropdownMenu/DropdownMenuItem.jsx";
import Dialog from "../../../../../../design-system/components/Dialog/Dialog.jsx";
import { getConfirmAbortButtons } from "../../../../../../design-system/components/Confirm/ConfirmAbortButtons.jsx";
import styles from "./GroupDeleteButton.css.ts";

/**
 * Renders a button with functionality to delete a small team within a workshop, including a confirmation dialog.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {Object} props.workshop - The workshop object containing details of the current workshop.
 * @param {string} props.workshop.id - The unique identifier for the workshop.
 * @param {Object} props.smallTeam - The small team object to be deleted.
 * @param {string} props.smallTeam.id - The unique identifier for the small team.
 * @param {string} props.smallTeam.name - The name of the small team displayed in the dialog.
 * @return {JSX.Element} A component containing the delete button and confirmation dialog.
 */
function GroupDeleteButton({ workshop, smallTeam }) {
  const [open, setOpen] = useState(false);
  const [doDeleteSmallTeam] = useMutation(MUTATIONS.deleteSmallTeam);

  function handleDeleteSmallTeam() {
    setOpen(false);

    doDeleteSmallTeam({
      workshopId: workshop.id,
      smallTeamId: smallTeam.id,
    });
  }

  function handleOpen() {
    setOpen(true);
  }

  return (
    <>
      <DropdownMenuItem icon="bin" onClick={handleOpen}>
        Gruppe löschen
      </DropdownMenuItem>

      <Dialog
        open={open}
        setOpen={setOpen}
        title={`${smallTeam.name} löschen?`}
        buttons={getConfirmAbortButtons(
          setOpen,
          handleDeleteSmallTeam,
          "Löschen",
        )}
      >
        <p className={styles.dialogText}>
          Bist du sicher, dass du die Gruppe löschen möchtest?
        </p>
        <p className={styles.warningText}>
          Alle Schüler*innen, die aktuell noch in der Gruppe sind, verlieren
          dadurch ihre Gruppenzugehörigkeit.
        </p>
      </Dialog>
    </>
  );
}

export default GroupDeleteButton;
